import { render } from "./haircareDiag.vue?vue&type=template&id=20eff275"
import script from "./haircareDiag.vue?vue&type=script&lang=js"
export * from "./haircareDiag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__